import type {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';

type LShapeFootprintVariables = Pick<
    TemplateVariable,
    | 'hasLShapedShelves'
    | 'isCornerProduct'
    | 'isLShapeDrawerProduct'
    | 'isLShapePanel'
    | 'isLShapedPantry'
>;

/**
 * Return/blind pantries (isReturnProduct + shelfType 'PANTRY') are deliberately
 * excluded: they are 2-part products, a rectangular carcass plus a separate
 * return panel, and they have their own renderer
 * (renderLShapedPanelForPantryReturn) apart from the true L-shape pantry
 * renderer. Treating them as an L footprint routes them through the L-shape leg
 * builder (7 legs) and the L-shape door transform, which misaligns both.
 * @param {LShapeFootprintVariables} [variables] - Parsed template variables
 * @return {boolean} True if the product carcass has an L-shaped footprint
 */
export const hasLShapeFootprint = (
    variables?: LShapeFootprintVariables
): boolean =>
    Boolean(
        variables?.hasLShapedShelves ||
        variables?.isCornerProduct ||
        variables?.isLShapeDrawerProduct ||
        variables?.isLShapePanel ||
        variables?.isLShapedPantry
    );
